import { useAuth } from "../auth/AuthContext";

/**
 * Swagger-UI-inspired Authorize button. PRD-002 DoD: visible on every
 * page, opens the JWT-paste modal on click, swaps state when a JWT is
 * cached.
 *
 * - No JWT → open-lock icon, "Authorize" label, emphasized green CTA.
 * - JWT cached → closed-lock icon, "Authorized" label, muted state.
 *   Click still opens the modal so the user can paste a fresh token.
 */
export function AuthorizeButton() {
    const { jwt, openModal } = useAuth();
    const authed = jwt !== null;
    return (
        <button
            type="button"
            className={
                authed ? "authorize-btn authorize-btn--auth" : "authorize-btn authorize-btn--unauth"
            }
            onClick={openModal}
            data-testid="authorize-button"
            aria-label={authed ? "Re-authorize (replace cached JWT)" : "Authorize"}
        >
            <i
                className={authed ? "fa-solid fa-lock" : "fa-solid fa-lock-open"}
                aria-hidden="true"
            />
            <span>{authed ? "Authorized" : "Authorize"}</span>
        </button>
    );
}
